var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { brand } from "../Brand";
import { spacingBuilder, fontSizeBuilder, borderRadiusBuilder, borderWidthBuilder, fixedHeightBuilder, neutralColorsBuilder, } from "../constants";
export var global = {
    spacing: __assign({}, spacingBuilder),
    fontSize: __assign({}, fontSizeBuilder),
    borderRadius: __assign({}, borderRadiusBuilder),
    borderWidth: __assign({}, borderWidthBuilder),
    fixedHeight: __assign({}, fixedHeightBuilder),
    neutrals: __assign({}, neutralColorsBuilder),
};
export var defaultTheme = __assign(__assign({}, global), { brand: brand });
